import { useAppState } from '@upheal/shared/state';

import { isNewVideoCallingEnabled } from '../utils/isNewVideoCallingEnabled';

export const useIsNewVideoCallingEnabled = (): boolean => {
    const { user } = useAppState();
    const orgId = user?.organizations?.[0]?.id;

    return isNewVideoCallingEnabled(orgId);
};
